// Hook odpowiedzialny za pobranie szczegółów odbiorcy

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IReceiverDetails {
  id: number;
  lp?: number;
  name: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  phone: string | null;
  address: {
    street: string | null;
    building: string | null;
    apartment: string | null;
    postal_code: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    country_code: string | null;
  };
}

const getReceiverDetails = (id: number): Promise<IReceiverDetails> =>
  axios.get(`/receivers/${id}`);

export const useGetReceiverDetails = (
  id: number,
  options?: UseQueryOptions<IReceiverDetails, IError>
) =>
  useQuery<IReceiverDetails, IError>(
    ['receiver-details', id],
    () => getReceiverDetails(id),
    {
      ...options,
      enabled: options?.enabled !== false && id > 0
    }
  );
